import React from 'react';
import FamilyMembersFilterButtons, { type FilterType } from './FamilyMembersFilterButtons';
import MembersPeopleFiltersBar from './MembersPeopleFiltersBar';
import type { MembersPeopleFilters } from '@/types/members-list';

export type { FilterType };

interface FamilyMembersFilterBarProps {
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  peopleCount: number;
  petsCount: number;
  peopleFilters?: MembersPeopleFilters;
  onPeopleFiltersChange?: (filters: MembersPeopleFilters) => void;
}

const FamilyMembersFilterBar: React.FC<FamilyMembersFilterBarProps> = ({
  currentFilter,
  onFilterChange,
  peopleCount,
  petsCount,
  peopleFilters,
  onPeopleFiltersChange
}) => {
  const showPeopleFilters = currentFilter !== 'pets' && peopleFilters != null && onPeopleFiltersChange != null;

  return (
    <div className="members-filter-bar">
      <div className="members-filter-bar__start">
        <FamilyMembersFilterButtons
          currentFilter={currentFilter}
          onFilterChange={onFilterChange}
          peopleCount={peopleCount}
          petsCount={petsCount}
        />
        {showPeopleFilters && <MembersPeopleFiltersBar filters={peopleFilters} onChange={onPeopleFiltersChange} />}
      </div>
    </div>
  );
};

export default FamilyMembersFilterBar;
